// $(function(){


// 	$('.policy-check .js-submit').on('click', function(){
// 		let $table = $('.policy-info table');
// 		console.log('1')
// 		setTimeout(function(){
		  
// 			if ($table.length) {

// 				$table.each(function(){
// 					let $this = $(this),
// 						width = $this.innerWidth();

// 					$this.wrap("<div class='table-wrapper'></div>");
// 					$this.parent('.table-wrapper').css('max-width', width)
// 				});
// 			}
// 		}, 4000);


// 	})

// });